/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Availability of a gateway
 * @export
 * @interface GatewayAvailability
 */
export interface GatewayAvailability {
    /**
     * The gateway code
     * @type {string}
     * @memberof GatewayAvailability
     */
    code: string;
    /**
     * Availability of outbound flight
     * @type {boolean}
     * @memberof GatewayAvailability
     */
    outbound: boolean;
    /**
     * Availability of inbound flight
     * @type {boolean}
     * @memberof GatewayAvailability
     */
    inbound: boolean;
}

/**
 * Check if a given object implements the GatewayAvailability interface.
 */
export function instanceOfGatewayAvailability(value: object): value is GatewayAvailability {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('outbound' in value) || value['outbound'] === undefined) return false;
    if (!('inbound' in value) || value['inbound'] === undefined) return false;
    return true;
}

export function GatewayAvailabilityFromJSON(json: any): GatewayAvailability {
    return GatewayAvailabilityFromJSONTyped(json, false);
}

export function GatewayAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GatewayAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'outbound': json['outbound'],
        'inbound': json['inbound'],
    };
}

export function GatewayAvailabilityToJSON(json: any): GatewayAvailability {
    return GatewayAvailabilityToJSONTyped(json, false);
}

export function GatewayAvailabilityToJSONTyped(value?: GatewayAvailability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'outbound': value['outbound'],
        'inbound': value['inbound'],
    };
}

